export const API_ERROR_KEYS = {
  EMPLOYEE_GENERAL_HAS_ACTIVE_RESERVATIONS: 'Employee.General.HasActiveReservations',
  INTERNAL_NOTE_TARGET_NOT_IN_VENDOR_SCOPE: 'InternalNote.Target.NotInVendorScope',
  SERVICE_VENDOR_SERVICE_GENERAL_HAS_ACTIVE_RESERVATIONS: 'ServiceVendorService.General.HasActiveReservations',
  SUBSCRIPTION_EMPLOYEE_LIMIT_REACHED: 'VendorSubscription.Employee.LimitReached',
} as const;

export const ERROR_KEY_TO_FIELD_MAP: Record<string, string> = {
  'serviceVendor.Name': 'name',
  'serviceVendor.Address.Street': 'street',
  'serviceVendor.Address.City': 'city',
  'serviceVendor.Address.PostalCode': 'postalCode',
  'serviceVendor.Address.Voivodeship': 'voivodeship',
  'serviceVendor.Phone': 'phone',
  'serviceVendor.Email': 'email',
  'serviceVendor.ServiceTypeId': 'serviceTypeId',
  'serviceVendor.Latitude': 'latitude',
  'serviceVendor.Longitude': 'longitude',
  'serviceVendor.Location.Address': 'street',
  'serviceVendor.Website': 'website',
  'serviceVendor.PriceList': 'priceList',
};

export const STATUS_CODE_MESSAGES: Record<number, string> = {
  400: 'Nieprawidłowe dane',
  401: 'Brak autoryzacji',
  403: 'Brak dostępu',
  404: 'Nie znaleziono',
  500: 'Błąd serwera',
};

export const ERROR_CODE_MESSAGES: Record<string, string> = {
  'Idempotency.General.RequestInProgress': 'Poprzednia próba jest jeszcze przetwarzana. Poczekaj chwilę i spróbuj ponownie.',
  'Idempotency.General.KeyReused': 'Dane zmieniły się w trakcie wysyłania. Spróbuj zapisać jeszcze raz.',
  'Pet.Name.Invalid': 'Imię pupila może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'ClientProfile.FirstName.Invalid': 'Imię może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'ClientProfile.LastName.Invalid': 'Nazwisko może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'Employee.FirstName.Invalid': 'Imię pracownika może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'Employee.LastName.Invalid': 'Nazwisko pracownika może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'ExternalReservation.Client.FirstNameInvalid': 'Imię klienta może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'ExternalReservation.Client.LastNameInvalid': 'Nazwisko klienta może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'ClaimRequest.FirstName.Required': 'Imię jest wymagane.',
  'ClaimRequest.FirstName.TooShort': 'Imię musi mieć co najmniej 2 znaki.',
  'ClaimRequest.FirstName.TooLong': 'Imię nie może przekraczać 50 znaków.',
  'ClaimRequest.FirstName.Invalid': 'Imię może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'ClaimRequest.LastName.Required': 'Nazwisko jest wymagane.',
  'ClaimRequest.LastName.TooShort': 'Nazwisko musi mieć co najmniej 2 znaki.',
  'ClaimRequest.LastName.TooLong': 'Nazwisko nie może przekraczać 50 znaków.',
  'ClaimRequest.LastName.Invalid': 'Nazwisko może zawierać tylko litery, spacje, myślniki i apostrofy.',
  'CalendarIntegration.Connection.MissingEmail': 'Adres e-mail konta Google jest wymagany.',
  'CalendarIntegration.Connection.MissingToken': 'Token odświeżania Google jest wymagany.',
  'CalendarIntegration.Connection.NotFound': 'Nie znaleziono połączenia z Kalendarzem Google.',
  'CalendarIntegration.Connection.AlreadyRevoked': 'Połączenie z Kalendarzem Google jest już rozłączone.',
  'CalendarIntegration.EventLink.NotFound': 'Nie znaleziono powiązanego wydarzenia w Kalendarzu Google.',

  'ClaimRequest.Consent.RepresentationRequired': 'Akceptacja oświadczenia o reprezentacji jest wymagana.',
  'ClaimRequest.Consent.TermsRequired': 'Akceptacja regulaminu jest wymagana.',
  'ClaimRequest.General.AlreadyReviewed': 'Ten wniosek o przejęcie profilu został już rozpatrzony.',
  'ClaimRequest.General.NotApproved': 'Tylko zatwierdzone wnioski o przejęcie profilu mogą zostać sfinalizowane.',
  'ClaimRequest.General.NotFound': 'Nie znaleziono wniosku o przejęcie profilu.',
  'ClaimRequest.General.VendorAlreadyClaimed': 'Ten usługodawca ma już właściciela.',

  'ClientProfile.AccountDeletion.DescriptionTooLong': 'Opis nie może przekraczać 1000 znaków.',
  'ClientProfile.AccountDeletion.ReasonRequired': 'Podaj powód usunięcia konta.',
  'ClientProfile.AccountDeletion.ReasonTooLong': 'Powód nie może przekraczać 200 znaków.',
  'ClientProfile.FirstName.Required': 'Imię jest wymagane.',
  'ClientProfile.FirstName.TooLong': 'Imię nie może przekraczać 50 znaków.',
  'ClientProfile.FirstName.TooShort': 'Imię musi mieć co najmniej 2 znaki.',
  'ClientProfile.General.AlreadyExists': 'Profil już istnieje dla tego użytkownika.',
  'ClientProfile.General.NotFound': 'Nie znaleziono profilu.',
  'ClientProfile.General.WrongStateTransition': 'Ta zmiana stanu jest niedozwolona.',
  'ClientProfile.LastName.Required': 'Nazwisko jest wymagane.',
  'ClientProfile.LastName.TooLong': 'Nazwisko nie może przekraczać 50 znaków.',
  'ClientProfile.LastName.TooShort': 'Nazwisko musi mieć co najmniej 2 znaki.',
  'ClientProfile.Phone.AlreadyInUse':
    'Ten numer telefonu jest już przypisany do innego konta. Zaloguj się metodą użytą wcześniej lub skontaktuj się z nami.',
  'ClientProfile.Phone.CodeExpired': 'Kod weryfikacyjny wygasł. Wyślij nowy kod.',
  'ClientProfile.Phone.InvalidCode': 'Nieprawidłowy kod weryfikacyjny.',
  'ClientProfile.Phone.NoCodeGenerated': 'Kod weryfikacyjny nie został wygenerowany.',
  'ClientProfile.Phone.NotSet': 'Numer telefonu nie został ustawiony.',
  'ClientProfile.Phone.ResendTooSoon': 'Kod został już wysłany. Odczekaj chwilę przed ponowną próbą.',
  'ClientProfile.Phone.SendLimitReached': 'Wysłano zbyt wiele kodów weryfikacyjnych. Spróbuj ponownie później.',

  'ClientSubscription.General.WrongStateTransition': 'Ta zmiana stanu subskrypcji jest niedozwolona.',
  'ClientSubscription.Premium.Required': 'Ta funkcja wymaga aktywnej subskrypcji Premium.',
  'ClientSubscription.Webhook.MissingRequiredFields': 'Wystąpił błąd po stronie systemu płatności.',
  'ClientSubscription.Webhook.UnknownUser': 'Wystąpił błąd po stronie systemu płatności.',

  'EmailAddress.InvalidFormat': 'Nieprawidłowy format adresu e-mail.',
  'EmailAddress.Required': 'Adres e-mail jest wymagany.',
  'EmailAddress.TooLong': 'Adres e-mail nie może przekraczać 100 znaków.',

  'Employee.FirstName.Empty': 'Imię pracownika jest wymagane.',
  'Employee.FirstName.TooLong': 'Imię pracownika nie może przekraczać 50 znaków.',
  'Employee.General.HasActiveExternalReservations': 'Nie można dezaktywować pracownika z nadchodzącymi rezerwacjami zewnętrznymi. Usuń je najpierw.',
  'Employee.General.HasActiveReservations': 'Nie można dezaktywować pracownika z nadchodzącymi rezerwacjami. Anuluj lub zakończ je najpierw.',
  'Employee.General.NotFound': 'Nie znaleziono pracownika.',
  'Employee.LastName.Empty': 'Nazwisko pracownika jest wymagane.',
  'Employee.LastName.TooLong': 'Nazwisko pracownika nie może przekraczać 50 znaków.',
  'Employee.Position.TooLong': 'Stanowisko pracownika nie może przekraczać 60 znaków.',

  'EmployeeSchedule.General.BlockOverlap': 'Podane bloki czasowe nakładają się na siebie.',
  'EmployeeSchedule.General.NotFound': 'Nie znaleziono grafiku pracownika.',
  'EmployeeSchedule.Period.DayNotInRange': 'Wybrany dzień tygodnia nie występuje w podanym zakresie dat grafiku.',
  'EmployeeSchedule.Period.DuplicateDay': 'Każdy dzień tygodnia może wystąpić w grafiku tylko raz.',
  'EmployeeSchedule.Period.ExceedsMaxRange': 'Grafik nie może kończyć się później niż 60 dni od dziś.',
  'EmployeeSchedule.Period.InvalidRange': 'Data zakończenia musi być po dacie rozpoczęcia.',
  'EmployeeSchedule.Period.NoDays': 'Wybierz co najmniej jeden dzień tygodnia.',
  'EmployeeSchedule.Period.PeriodOverlap': 'Ten grafik pokrywa się z istniejącym grafikiem dla tych samych dni tygodnia.',
  'EmployeeSchedule.Service.NoServices': 'Wybierz co najmniej jedną usługę dla grafiku.',
  'EmployeeSchedule.Service.ServiceNotFound': 'Jedna lub więcej wybranych usług nie istnieje.',
  'EmployeeSchedule.Time.InvalidRange': 'Czas rozpoczęcia musi być przed czasem zakończenia.',
  'EmployeeSchedule.Time.TooShort': 'Grafik musi trwać co najmniej 30 minut.',

  'EmployeeTimeOff.Date.InPast': 'Okres wolny nie może rozpoczynać się w przeszłości.',
  'EmployeeTimeOff.Date.InvalidRange': 'Data „od” musi być wcześniejsza lub równa „do”.',
  'EmployeeTimeOff.General.ConflictsWithReservations':
    'Nie można dodać okresu wolnego — pracownik ma aktywne rezerwacje w tych dniach. Najpierw je anuluj.',
  'EmployeeTimeOff.General.DuplicateDate': 'Pracownik ma już okres wolny pokrywający się z wybranymi datami.',
  'EmployeeTimeOff.General.NotFound': 'Nie znaleziono okresu wolnego.',
  'EmployeeTimeOff.Reason.TooLong': 'Powód nie może przekraczać 200 znaków.',

  'EndpointErrors.General.MissingFiles': 'Nie przesłano żadnych plików.',
  'EndpointErrors.General.RateLimitExceeded': 'Zbyt wiele żądań. Spróbuj ponownie za kilka minut.',

  'ExternalReservation.Client.EmailEmpty': 'E-mail klienta jest wymagany.',
  'ExternalReservation.Client.EmailTooLong': 'E-mail klienta nie może przekraczać 255 znaków.',
  'ExternalReservation.Client.FirstNameEmpty': 'Imię klienta jest wymagane.',
  'ExternalReservation.Client.FirstNameTooLong': 'Imię klienta nie może przekraczać 50 znaków.',
  'ExternalReservation.Client.LastNameEmpty': 'Nazwisko klienta jest wymagane.',
  'ExternalReservation.Client.LastNameTooLong': 'Nazwisko klienta nie może przekraczać 50 znaków.',
  'ExternalReservation.Client.NoteTooLong': 'Notatka nie może przekraczać 500 znaków.',
  'ExternalReservation.Client.PhoneEmpty': 'Telefon klienta jest wymagany.',
  'ExternalReservation.Client.PhoneTooLong': 'Telefon klienta nie może przekraczać 20 znaków.',
  'ExternalReservation.General.NotFound': 'Nie znaleziono rezerwacji zewnętrznej.',
  'ExternalReservation.Service.NotFound': 'Nie znaleziono wybranej usługi.',
  'ExternalReservation.Time.InvalidRange': 'Czas rozpoczęcia musi być przed czasem zakończenia.',
  'ExternalReservation.Time.Overlap': 'Pracownik ma już rezerwację w tym czasie.',
  'ExternalReservation.Time.TooShort': 'Rezerwacja zewnętrzna musi trwać co najmniej 15 minut.',

  'FeatureFlag.General.Disabled': 'Ta funkcja jest obecnie niedostępna.',

  'GoogleCalendarClient.CalendarNotFound': 'Kalendarz Google nie istnieje lub nie jest udostępniony połączonemu kontu.',
  'GoogleCalendarClient.CreateFailed': 'Nie udało się utworzyć wydarzenia w Kalendarzu Google.',
  'GoogleCalendarClient.DeleteFailed': 'Nie udało się usunąć wydarzenia w Kalendarzu Google.',
  'GoogleCalendarClient.ExchangeFailed': 'Nie udało się wymienić kodu autoryzacji Google na tokeny.',
  'GoogleCalendarClient.InsufficientScopes': 'Konto Google nie przyznało dostępu do kalendarza. Połącz ponownie i zaznacz zgodę na kalendarz.',
  'GoogleCalendarClient.MissingEmailClaim': 'Token Google nie zawierał adresu e-mail.',
  'GoogleCalendarClient.MissingIdToken': 'Google nie zwróciło id_token — nie można ustalić adresu konta.',
  'GoogleCalendarClient.MissingRefreshToken': 'Google nie zwróciło tokenu odświeżania. Nie przyznano dostępu offline.',
  'GoogleCalendarClient.PullFailed': 'Nie udało się pobrać wydarzeń z Kalendarza Google.',
  'GoogleCalendarClient.TokenRevoked': 'Połączenie z Kalendarzem Google wygasło lub zostało cofnięte. Połącz ponownie.',
  'GoogleCalendarClient.UpdateFailed': 'Nie udało się zaktualizować wydarzenia w Kalendarzu Google.',

  'ImageFile.ContentType.Required': 'Typ pliku jest wymagany.',
  'ImageFile.FileName.Required': 'Nazwa pliku jest wymagana.',
  'ImageFile.Size.Invalid': 'Rozmiar pliku musi być większy niż 0.',

  'InternalNote.Body.Required': 'Treść notatki jest wymagana.',
  'InternalNote.Body.TooLong': 'Notatka nie może przekraczać 4000 znaków.',
  'InternalNote.General.NotFound': 'Nie znaleziono notatki.',
  'InternalNote.Target.NotInVendorScope': 'Nie możesz dodać notatki — ten pupil i klient nie mają u Ciebie żadnej rezerwacji.',

  'Notification.State.InvalidTransition': 'Tej operacji nie można wykonać dla powiadomienia w obecnym stanie.',

  'NotificationBroadcast.General.NotFound': 'Nie znaleziono wysyłki powiadomienia.',
  'NotificationBroadcast.General.AlreadySent': 'Powiadomienie z tą datą wejścia w życie zostało już wysłane do wszystkich.',
  'NotificationBroadcast.General.EffectiveDateRequired': 'Data wejścia w życie jest wymagana.',
  'NotificationBroadcast.General.EffectiveDateInPast': 'Data wejścia w życie musi być w przyszłości.',
  'NotificationBroadcast.Test.RecipientNotFound': 'Nie znaleziono aktywnego konta o podanym identyfikatorze.',

  'OAuthStateProtector.CorruptedPayload': 'Nie udało się odczytać zawartości parametru stanu.',
  'OAuthStateProtector.Expired': 'Parametr stanu wygasł.',
  'OAuthStateProtector.InvalidSignature': 'Podpis parametru stanu jest nieprawidłowy.',
  'OAuthStateProtector.MalformedState': 'Parametr stanu ma nieprawidłowy format.',

  'Pet.Allergies.AllergyNotFound': 'Nie znaleziono alergii.',
  'Pet.Allergies.NameRequired': 'Nazwa alergii jest wymagana.',
  'Pet.Allergies.NameTooLong': 'Nazwa alergii nie może przekraczać 200 znaków.',
  'Pet.Allergies.DuplicateName': 'Ta alergia jest już dodana.',
  'Pet.Breed.NotAllowedForSpecies': 'Rasa nie jest dozwolona dla tego gatunku.',
  'Pet.Breed.NotFound': 'Nie znaleziono wybranej rasy.',
  'Pet.CustomSpeciesName.NotAllowedForSpecies': 'Nazwa gatunku nie jest dozwolona dla tego gatunku.',
  'Pet.CustomSpeciesName.Required': 'Nazwa gatunku jest wymagana dla tego gatunku.',
  'Pet.CustomSpeciesName.TooLong': 'Nazwa gatunku nie może przekraczać 100 znaków.',
  'Pet.DateOfBirth.InFuture': 'Data urodzenia nie może być w przyszłości.',
  'Pet.DateOfBirth.TooOld': 'Data urodzenia nie może być wcześniejsza niż 30 lat temu.',
  'Pet.Dewormings.InvalidDateRange': 'Data wykonania nie może być późniejsza niż data przypomnienia.',
  'Pet.Dewormings.NextDueOnTooFar': 'Termin kolejnego odrobaczania jest zbyt odległy.',
  'Pet.Dewormings.NotFound': 'Nie znaleziono wpisu odrobaczania.',
  'Pet.Dewormings.NoteTooLong': 'Notatka nie może przekraczać 500 znaków.',
  'Pet.Dewormings.OverlappingPeriod': 'Okresy odrobaczania nie mogą się nakładać — muszą następować jeden po drugim.',
  'Pet.Dewormings.PerformedOnBeforeBirth': 'Data wykonania nie może być wcześniejsza niż data urodzenia pupila.',
  'Pet.Dewormings.PerformedOnInFuture': 'Data wykonania nie może być z przyszłości.',
  'Pet.General.NotFound': 'Nie znaleziono pupila.',
  'Pet.General.WrongOwner': 'Nie jesteś właścicielem tego pupila.',
  'Pet.General.WrongStateTransition': 'Ta zmiana stanu jest niedozwolona.',
  'Pet.HealthAttributes.InvalidMicrochip': 'Numer mikroczipa może zawierać tylko od 1 do 15 cyfr.',
  'Pet.Invitations.AlreadyResolved': 'To zaproszenie zostało już zrealizowane.',
  'Pet.Invitations.DuplicatePending': 'Istnieje już oczekujące zaproszenie dla tego odbiorcy.',
  'Pet.Invitations.Expired': 'To zaproszenie wygasło.',
  'Pet.Invitations.NotFound': 'Nie znaleziono zaproszenia.',
  'Pet.Invitations.NotResolved': 'To zaproszenie nie zostało jeszcze przypisane do zarejestrowanego konta.',
  'Pet.Invitations.NotTargetUser': 'To zaproszenie nie było adresowane do bieżącego użytkownika.',
  'Pet.Invitations.TargetRequired': 'Zaproszenie musi wskazywać kod konta.',
  'Pet.Invitations.TokenRequired': 'Token zaproszenia jest wymagany.',
  'Pet.Journal.EntryNotFound': 'Nie znaleziono wpisu w dzienniku.',
  'Pet.Journal.OccurredAtBeforeBirth': 'Data zdarzenia nie może być wcześniejsza niż data urodzenia pupila.',
  'Pet.Journal.OccurredAtInFuture': 'Data obserwacji nie może być z przyszłości.',
  'Pet.Journal.TextRequired': 'Treść wpisu w dzienniku jest wymagana.',
  'Pet.MedicalDocuments.BlobUrlRequired': 'Adres URL dokumentu jest wymagany.',
  'Pet.MedicalDocuments.DocumentDateBeforeBirth': 'Data dokumentu nie może być wcześniejsza niż data urodzenia pupila.',
  'Pet.MedicalDocuments.DocumentDateInFuture': 'Data dokumentu nie może być z przyszłości.',
  'Pet.MedicalDocuments.DocumentNotFound': 'Nie znaleziono dokumentu medycznego.',
  'Pet.MedicalDocuments.NoteTooLong': 'Notatka nie może przekraczać 500 znaków.',
  'Pet.MedicalDocuments.ReservationMismatch': 'Wskazana wizyta nie dotyczy tego pupila.',
  'Pet.Medications.DoseUnitNotFound': 'Wskazana jednostka dawki nie istnieje.',
  'Pet.Medications.DoseUnitTooLong': 'Jednostka dawki nie może przekraczać 50 znaków.',
  'Pet.Medications.EndDateTooFar': 'Data zakończenia jest zbyt odległa.',
  'Pet.Medications.InvalidDateRange': 'Data zakończenia nie może być wcześniejsza niż data rozpoczęcia.',
  'Pet.Medications.InvalidDaysOfWeek': 'Wybrane dni tygodnia są nieprawidłowe.',
  'Pet.Medications.DaysOfWeekOutsidePeriod': 'Żaden z wybranych dni tygodnia nie wypada między datą rozpoczęcia a zakończenia.',
  'Pet.Medications.InvalidDoseAmount': 'Wielkość dawki musi być większa od zera.',
  'Pet.Medications.InvalidInterval': 'Odstęp musi wynosić co najmniej jeden dzień.',
  'Pet.Medications.NameRequired': 'Nazwa leku jest wymagana.',
  'Pet.Medications.NameTooLong': 'Nazwa leku nie może przekraczać 200 znaków.',
  'Pet.Medications.NoteTooLong': 'Notatka nie może przekraczać 500 znaków.',
  'Pet.Medications.ReminderTimesRequired': 'Wymagana jest co najmniej jedna godzina przypomnienia.',
  'Pet.Medications.ScheduleNotFound': 'Nie znaleziono planu podawania leku.',
  'Pet.Medications.StartDateBeforeBirth': 'Data rozpoczęcia nie może być wcześniejsza niż data urodzenia pupila.',
  'Pet.Medications.StartDateTooFar': 'Data rozpoczęcia jest zbyt odległa.',
  'Pet.Name.Required': 'Imię pupila jest wymagane.',
  'Pet.Name.TooLong': 'Imię pupila nie może przekraczać 100 znaków.',
  'Pet.Name.TooShort': 'Imię pupila musi mieć co najmniej 2 znaki.',
  'Pet.Owners.AlreadyOwner': 'Ten użytkownik jest już właścicielem tego pupila.',
  'Pet.Owners.CanOnlyRemoveInvitedByYou': 'Możesz usunąć tylko współwłaścicieli, których sam zaprosiłeś.',
  'Pet.Owners.CannotRemovePrimary': 'Nie można usunąć głównego właściciela.',
  'Pet.Owners.NotAnOwner': 'Wskazany użytkownik nie jest właścicielem tego pupila.',
  'Pet.Owners.OnlyPrimaryCanDelete': 'Tylko główny właściciel może usunąć pupila.',
  'Pet.Owners.OnlyPrimaryCanManage': 'Tylko główny właściciel może zarządzać współwłaścicielami.',
  'Pet.Owners.PrimaryCannotLeave': 'Główny właściciel nie może zrezygnować — przekaż lub usuń pupila.',
  'Pet.Owners.PhoneNotVerified': 'Ta funkcja wymaga potwierdzonego numeru telefonu.',
  'Pet.Owners.ProfileRequired': 'Aby zostać właścicielem pupila, najpierw dokończ zakładanie profilu.',
  'Pet.Owners.RecipientNotResolved': 'Nie znaleziono użytkownika dla podanego kodu konta.',
  'Pet.Photos.BlobUrlRequired': 'Adres URL zdjęcia jest wymagany.',
  'Pet.Photos.FileTooLarge': 'Rozmiar zdjęcia nie może przekraczać 10 MB.',
  'Pet.Photos.InvalidFileSize': 'Rozmiar pliku musi być większy niż 0.',
  'Pet.Photos.InvalidFileType': 'Nieprawidłowy typ pliku. Dozwolone: JPEG, PNG i WebP.',
  'Pet.Photos.MaxPhotosLimitExceeded': 'Osiągnięto maksymalną liczbę zdjęć (8).',
  'Pet.Photos.PhotoNotFound': 'Nie znaleziono zdjęcia.',
  'Pet.Species.NotFound': 'Nie znaleziono gatunku.',
  'Pet.Vaccinations.CustomNameTooLong': 'Nazwa preparatu nie może przekraczać 200 znaków.',
  'Pet.Vaccinations.InvalidDateRange': 'Data wykonania nie może być późniejsza niż termin kolejnego szczepienia.',
  'Pet.Vaccinations.NextDueOnTooFar': 'Termin kolejnego szczepienia jest zbyt odległy.',
  'Pet.Vaccinations.NotFound': 'Nie znaleziono szczepienia.',
  'Pet.Vaccinations.NoteTooLong': 'Notatka nie może przekraczać 500 znaków.',
  'Pet.Vaccinations.NumberTooLong': 'Numer szczepienia nie może przekraczać 50 znaków.',
  'Pet.Vaccinations.PerformedOnBeforeBirth': 'Data wykonania nie może być wcześniejsza niż data urodzenia pupila.',
  'Pet.Vaccinations.PerformedOnInFuture': 'Data wykonania nie może być z przyszłości.',
  'Pet.Vaccinations.ProductAndCustomNameConflict': 'Szczepienie nie może mieć jednocześnie produktu ze słownika i własnej nazwy produktu.',
  'Pet.Vaccinations.ProductRequired': 'Szczepienie wymaga produktu ze słownika lub własnej nazwy produktu.',
  'Pet.WeightEntries.EntryNotFound': 'Nie znaleziono wpisu wagi.',
  'Pet.WeightEntries.MeasuredOnBeforeBirth': 'Data pomiaru nie może być wcześniejsza niż data urodzenia pupila.',
  'Pet.WeightEntries.MeasuredOnInFuture': 'Data pomiaru nie może być z przyszłości.',
  'Pet.WeightEntries.NoteTooLong': 'Notatka nie może przekraczać 200 znaków.',
  'Pet.WeightEntries.WeightOutOfRange': 'Waga musi mieścić się w zakresie (0; 200] kg.',

  'PhoneNumber.InvalidFormat': 'Nieprawidłowy format numeru telefonu.',
  'PhoneNumber.Required': 'Numer telefonu jest wymagany.',
  'PhoneNumber.TooLong': 'Numer telefonu nie może przekraczać 20 znaków.',
  'PhoneNumber.TooShort': 'Numer telefonu jest za krótki.',

  'PushToken.TooLong': 'Token powiadomień push jest zbyt długi.',

  'Reservation.ClientProfile.NotFound': 'Aby utworzyć rezerwację, musisz najpierw uzupełnić swój profil.',
  'Reservation.ClientProfile.PhoneNotVerified': 'Aby utworzyć rezerwację, musisz zweryfikować swój numer telefonu.',
  'Reservation.General.CannotCancel': 'Tej rezerwacji nie można anulować w obecnym stanie.',
  'Reservation.General.CannotRebook': 'Tej rezerwacji nie można przebookować w obecnym stanie.',
  'Reservation.General.NotOwner': 'Nie jesteś właścicielem tej rezerwacji.',
  'Reservation.General.OutsideSchedule': 'Wybrany termin jest poza grafikiem pracownika.',
  'Reservation.General.TimeSlotConflict': 'Pracownik ma już rezerwację w tym czasie.',
  'Reservation.State.InvalidTransition': 'Ta zmiana stanu rezerwacji jest niedozwolona.',
  'Reservation.TimeSlot.DateInThePast': 'Nie można utworzyć rezerwacji na datę z przeszłości.',
  'Reservation.TimeSlot.InvalidRange': 'Czas rozpoczęcia musi być przed czasem zakończenia.',
  'Reservation.TimeSlot.TooShort': 'Rezerwacja musi trwać co najmniej 15 minut.',

  'ServiceVendor.Address.CityRequired': 'Miejscowość jest wymagana.',
  'ServiceVendor.Address.CityTooLong': 'Miejscowość nie może przekraczać 100 znaków.',
  'ServiceVendor.Address.PostalCodeInvalid': 'Kod pocztowy musi mieć format XX-XXX.',
  'ServiceVendor.Address.PostalCodeRequired': 'Kod pocztowy jest wymagany.',
  'ServiceVendor.Address.StreetRequired': 'Ulica jest wymagana.',
  'ServiceVendor.Address.StreetTooLong': 'Ulica nie może przekraczać 200 znaków.',
  'ServiceVendor.Address.VoivodeshipInvalid': 'Województwo musi być jednym z 16 polskich województw.',
  'ServiceVendor.Address.VoivodeshipRequired': 'Województwo jest wymagane.',
  'ServiceVendor.General.NotExistingServiceType': 'Wybrany typ usługi nie istnieje.',
  'ServiceVendor.General.NotFound': 'Nie znaleziono dostawcy usług.',
  'ServiceVendor.General.WrongOwner': 'Nie jesteś właścicielem tego dostawcy usług.',
  'ServiceVendor.General.WrongStateTransition': 'Ta zmiana stanu jest niedozwolona.',
  'ServiceVendor.Location.InvalidLatitude': 'Szerokość geograficzna musi być między -90 a 90 stopni.',
  'ServiceVendor.Location.InvalidLongitude': 'Długość geograficzna musi być między -180 a 180 stopni.',
  'ServiceVendor.Location.AddressNotFound': 'Nie znaleźliśmy tego adresu. Sprawdź ulicę, numer, kod pocztowy i miejscowość.',
  'ServiceVendor.Location.LookupFailed': 'Nie udało się ustalić położenia adresu. Spróbuj ponownie za chwilę.',
  'ServiceVendor.Name.Required': 'Nazwa dostawcy usług jest wymagana.',
  'ServiceVendor.Name.TooLong': 'Nazwa dostawcy usług nie może przekraczać 200 znaków.',
  'ServiceVendor.Description.TooLong': 'Opis nie może przekraczać 1000 znaków.',
  'ServiceVendor.Name.TooShort': 'Nazwa dostawcy usług musi mieć co najmniej 2 znaki.',
  'ServiceVendor.Photos.BlobUrlRequired': 'Adres URL zdjęcia jest wymagany.',
  'ServiceVendor.Photos.MaxPhotosReached': 'Osiągnięto maksymalną liczbę zdjęć (10).',
  'ServiceVendor.Photos.PhotoNotFound': 'Nie znaleziono wybranego zdjęcia.',
  'ServiceVendor.Photos.PhotoSizeExceeded': 'Rozmiar zdjęcia nie może przekraczać 5 MB.',
  'ServiceVendor.Services.NotSupported': 'Ten typ dostawcy usług nie obsługuje konfiguracji usług.',
  'ServiceVendor.Website.InvalidFormat': 'Nieprawidłowy format adresu URL strony internetowej.',
  'ServiceVendor.Website.Required': 'Strona internetowa jest wymagana.',
  'ServiceVendor.Website.TooLong': 'Adres URL strony nie może przekraczać 200 znaków.',

  'ServiceVendorAgreement.Consent.RepresentationRequired': 'Akceptacja oświadczenia o reprezentacji jest wymagana.',
  'ServiceVendorAgreement.Consent.TermsRequired': 'Akceptacja regulaminu jest wymagana.',

  'ServiceVendorBusinessHours.General.NotFound': 'Nie znaleziono godzin pracy.',
  'ServiceVendorBusinessHours.General.Overlap': 'Te godziny pracy pokrywają się z istniejącymi godzinami dla tego dnia.',
  'ServiceVendorBusinessHours.Time.InvalidRange': 'Czas rozpoczęcia musi być przed czasem zakończenia.',
  'ServiceVendorBusinessHours.Time.Required': 'Godzina rozpoczęcia i zakończenia są wymagane, gdy nie zaznaczono opcji „czynne całą dobę”.',
  'ServiceVendorBusinessHours.Time.TooShort': 'Godziny pracy muszą trwać co najmniej 30 minut.',

  'ServiceVendorService.Duration.InvalidIncrement': 'Czas trwania usługi musi być wielokrotnością 15 minut.',
  'ServiceVendorService.Duration.TooLong': 'Czas trwania usługi nie może przekraczać 480 minut (8 godzin).',
  'ServiceVendorService.Duration.TooShort': 'Czas trwania usługi musi wynosić co najmniej 15 minut.',
  'ServiceVendorService.General.HasActiveReservations': 'Nie można dezaktywować usługi z nadchodzącymi rezerwacjami. Anuluj lub zakończ je najpierw.',
  'ServiceVendorService.General.NotFound': 'Nie znaleziono usługi.',
  'ServiceVendorService.Name.Empty': 'Nazwa usługi jest wymagana.',
  'ServiceVendorService.Name.TooLong': 'Nazwa usługi nie może przekraczać 100 znaków.',
  'ServiceVendorService.Price.InvalidValue': 'Cena musi być większa niż 0.',
  'ServiceVendorService.Price.TooHigh': 'Cena nie może przekraczać 100 000 PLN.',

  'Statistic.General.NotFound': 'Nie znaleziono statystyki.',

  'Stripe.CreateBillingPortalSessionFailed': 'Nie udało się otworzyć portalu rozliczeniowego Stripe.',
  'Stripe.CreateCustomerFailed': 'Nie udało się utworzyć konta klienta w Stripe.',
  'Stripe.CreateCustomerSessionFailed': 'Nie udało się utworzyć sesji klienta Stripe.',
  'Stripe.CustomerNotConfigured': 'Konto Stripe nie jest skonfigurowane dla tej subskrypcji.',
  'Stripe.UpdateCustomerFailed': 'Nie udało się zaktualizować konta klienta w Stripe.',

  'VendorSubscription.Booking.NotAllowed': 'Ten usługodawca nie przyjmuje obecnie nowych rezerwacji.',
  'VendorSubscription.Downgrade.MissingPeriodEnd': 'Nie udało się zweryfikować ważności subskrypcji.',
  'VendorSubscription.Downgrade.NotYetExpired': 'Subskrypcja jeszcze nie wygasła.',
  'VendorSubscription.Employee.LimitReached': 'Osiągnięto limit pracowników w bieżącym planie subskrypcji.',
  'VendorSubscription.General.NotFound': 'Nie znaleziono subskrypcji usługodawcy.',
  'VendorSubscription.General.WrongStateTransition': 'Ta zmiana stanu subskrypcji jest niedozwolona.',
  'VendorSubscription.Webhook.MissingRequiredFields': 'Wystąpił błąd po stronie systemu płatności.',
  'VendorSubscription.Webhook.UnknownProduct': 'Wystąpił błąd po stronie systemu płatności.',

  'ClaimRequestRepository.NotFound': 'Nie znaleziono zgłoszenia przejęcia wizytówki.',
  'ClientProfileRepository.NotFound': 'Nie znaleziono profilu klienta.',
  'ClientSubscriptionRepository.NotFound': 'Nie znaleziono subskrypcji.',
  'EmployeeScheduleRepository.NotFound': 'Nie znaleziono grafiku pracownika.',
  'EmployeeTimeOffRepository.NotFound': 'Nie znaleziono nieobecności pracownika.',
  'ExternalReservationRepository.NotFound': 'Nie znaleziono rezerwacji zewnętrznej.',
  'FeatureFlagRepository.NotFound': 'Nie znaleziono flagi funkcji.',
  'MeasurementUnitRepository.NotFound': 'Nie znaleziono jednostki miary.',
  'MedicalDocumentCategoryRepository.NotFound': 'Nie znaleziono kategorii dokumentu.',
  'NotificationTemplateRepository.NotFound': 'Nie znaleziono szablonu powiadomienia.',
  'PetRepository.NotFound': 'Nie znaleziono pupila.',
  'PetSpeciesRepository.NotFound': 'Nie znaleziono gatunku.',
  'ReservationRepository.NotFound': 'Nie znaleziono rezerwacji.',
  'ServiceTypeRepository.NotFound': 'Nie znaleziono typu usługi.',
  'ServiceVendorRepository.NotFound': 'Nie znaleziono usługodawcy.',
  'ServiceVendorServiceRepository.NotFound': 'Nie znaleziono usługi.',
  'SubscriptionEventRepository.NotFound': 'Nie znaleziono zdarzenia subskrypcji.',
  'VaccineProductRepository.NotFound': 'Nie znaleziono szczepionki.',
  'VendorSubscriptionRepository.NotFound': 'Nie znaleziono subskrypcji usługodawcy.',

  'Shop.Cart.NotFound': 'Koszyk wygasł. Dodaj produkty ponownie.',
  'Shop.Cart.Unavailable': 'Koszyk jest chwilowo niedostępny. Spróbuj ponownie za chwilę.',
  'Shop.Catalog.Unavailable': 'Sklep jest chwilowo niedostępny. Spróbuj ponownie za chwilę.',
  'Shop.Checkout.Unavailable': 'Kasa jest chwilowo niedostępna. Spróbuj ponownie za chwilę.',
  'Shop.Product.NotFound': 'Nie znaleziono tego produktu w sklepie.',
  'Shop.Product.OutOfStock': 'Tego produktu chwilowo nie ma w magazynie.',
  'Shop.Product.Unavailable': 'Ten produkt nie jest już dostępny w sklepie.',
  'Shop.Request.Invalid': 'Nieprawidłowe parametry wyszukiwania w sklepie.',
  'Shop.Orders.Unavailable': 'Nie udało się pobrać zamówień. Spróbuj ponownie za chwilę.',

  'email.SendFailed': 'Nie udało się wysłać wiadomości e-mail.',

  'place.AutocompleteFailed': 'Nie udało się pobrać podpowiedzi adresów.',
  'place.DetailsFetchFailed': 'Nie udało się pobrać szczegółów adresu.',
  'place.InputInvalid': 'Nieprawidłowe zapytanie autouzupełniania.',
  'place.MissingCity': 'Wybrany adres nie zawiera miejscowości.',
  'place.MissingCoordinates': 'Wybrany adres nie zawiera współrzędnych geograficznych.',
  'place.MissingPlaceId': 'Identyfikator miejsca jest wymagany.',
  'place.MissingPostalCode': 'Wybrany adres nie zawiera kodu pocztowego.',
  'place.MissingStreet': 'Wybrany adres nie zawiera ulicy.',

  'push.DeviceNotRegistered': 'Urządzenie nie jest już zarejestrowane do powiadomień push.',
  'push.SendFailed': 'Nie udało się wysłać powiadomienia push.',

  'sms.SendFailed': 'Nie udało się wysłać wiadomości SMS. Spróbuj ponownie.',
};

export const QUERY_KEYS = {
  SERVICE_VENDORS: 'service-vendors',
  SERVICE_TYPES: 'service-types',
  VENDOR_SERVICES: 'vendor-services',
  VENDOR_BUSINESS_HOURS: 'vendor-business-hours',
  RESERVATIONS: 'reservations',
  EMPLOYEES: 'employees',
  EMPLOYEE_SCHEDULES: 'employee-schedules',
  EMPLOYEE_TIME_OFFS: 'employee-time-offs',
  EXTERNAL_RESERVATIONS: 'external-reservations',
  WEEKLY_CALENDAR: 'weekly-calendar',
  WEEKLY_SUMMARY: 'weekly-summary',
  HEALTH_RECORDS: 'health-records',
  HEALTH_RECORD: 'health-record',
  SUBSCRIPTION: 'subscription',
  PRICING_CONFIG: 'pricing-config',
  APPOINTMENT_REQUESTS: 'appointment-requests',
  CLAIM_REQUESTS: 'claim-requests',
  INTERNAL_NOTES: 'internal-notes',
  EMPLOYEE_CALENDAR: 'employee-calendar',
  MEDICAL_DOCUMENTS: 'medical-documents',
  PET_HEALTH_PROFILE: 'pet-health-profile',
  FEATURE_FLAGS: 'feature-flags',
  NOTIFICATION_BROADCASTS: 'notification-broadcasts',
} as const;

export const TOAST_MESSAGES = {
  SERVICE_CREATED: 'Usługa została dodana',
  SERVICE_CREATE_ERROR: 'Nie udało się dodać usługi',
  SERVICE_UPDATED: 'Usługa została zaktualizowana',
  SERVICE_UPDATE_ERROR: 'Nie udało się zaktualizować usługi',
  SERVICE_DEACTIVATED: 'Usługa została dezaktywowana',
  SERVICE_DEACTIVATE_ERROR: 'Nie udało się dezaktywować usługi',
  SERVICE_RESTORED: 'Usługa przywrócona',
  SERVICE_RESTORE_ERROR: 'Nie udało się przywrócić usługi',

  BUSINESS_HOURS_CREATED: 'Godziny otwarcia zostały dodane',
  BUSINESS_HOURS_CREATE_ERROR: 'Nie udało się dodać godzin otwarcia',
  BUSINESS_HOURS_UPDATED: 'Godziny otwarcia zostały zaktualizowane',
  BUSINESS_HOURS_UPDATE_ERROR: 'Nie udało się zaktualizować godzin otwarcia',
  BUSINESS_HOURS_DELETED: 'Godziny otwarcia zostały usunięte',
  BUSINESS_HOURS_DELETE_ERROR: 'Nie udało się usunąć godzin otwarcia',

  PROFILE_UPDATED: 'Profil został zaktualizowany',
  PROFILE_UPDATE_ERROR: 'Nie udało się zaktualizować profilu',

  PHOTO_PROFILE_SET: 'Zdjęcie profilowe zostało ustawione',
  PHOTO_PROFILE_SET_ERROR: 'Nie udało się ustawić zdjęcia profilowego',
  PHOTO_DELETED: 'Zdjęcie zostało usunięte',
  PHOTO_DELETE_ERROR: 'Nie udało się usunąć zdjęcia',
  PHOTO_UPLOAD_ERROR: 'Nie udało się dodać zdjęcia',

  RESERVATION_CONFIRMED: 'Rezerwacja została potwierdzona',
  RESERVATION_CONFIRM_ERROR: 'Nie udało się potwierdzić rezerwacji',
  RESERVATION_REJECTED: 'Rezerwacja została odrzucona',
  RESERVATION_REJECT_ERROR: 'Nie udało się odrzucić rezerwacji',
  RESERVATION_CANCELLED: 'Rezerwacja została anulowana',
  RESERVATION_CANCEL_ERROR: 'Nie udało się anulować rezerwacji',
  RESERVATION_NO_SHOW: 'Klient został oznaczony jako nieobecny',
  RESERVATION_NO_SHOW_ERROR: 'Nie udało się oznaczyć klienta jako nieobecnego',

  EMPLOYEE_CREATED: 'Pracownik został dodany',
  EMPLOYEE_CREATE_ERROR: 'Nie udało się dodać pracownika',
  EMPLOYEE_UPDATED: 'Pracownik został zaktualizowany',
  EMPLOYEE_UPDATE_ERROR: 'Nie udało się zaktualizować pracownika',
  EMPLOYEE_DEACTIVATED: 'Pracownik został dezaktywowany',
  EMPLOYEE_DEACTIVATE_ERROR: 'Nie udało się dezaktywować pracownika',
  EMPLOYEE_RESTORED: 'Pracownik przywrócony',
  EMPLOYEE_RESTORE_ERROR: 'Nie udało się przywrócić pracownika',

  GOOGLE_CALENDAR_CONNECTED: 'Kalendarz Google został połączony',
  GOOGLE_CALENDAR_CONNECT_ERROR: 'Nie udało się połączyć z Kalendarzem Google',
  GOOGLE_CALENDAR_SCOPE_MISSING: 'Nie zaznaczono zgody na dostęp do Kalendarza Google. Spróbuj ponownie i zaznacz tę zgodę.',
  GOOGLE_CALENDAR_DISCONNECTED: 'Kalendarz Google został rozłączony',
  GOOGLE_CALENDAR_DISCONNECT_ERROR: 'Nie udało się rozłączyć Kalendarza Google',

  TIME_OFF_CREATED: 'Dzień wolny dodany',
  TIME_OFF_CREATE_ERROR: 'Nie udało się dodać dnia wolnego',
  TIME_OFF_UPDATED: 'Okres wolny zaktualizowany',
  TIME_OFF_UPDATE_ERROR: 'Nie udało się zaktualizować okresu wolnego',
  TIME_OFF_DELETED: 'Dzień wolny usunięty',
  TIME_OFF_DELETE_ERROR: 'Nie udało się usunąć dnia wolnego',

  SCHEDULE_SAVED: 'Grafik został zapisany',
  SCHEDULE_SAVE_ERROR: 'Nie udało się zapisać grafiku',
  SCHEDULE_DELETED: 'Grafik został usunięty',
  SCHEDULE_DELETE_ERROR: 'Nie udało się usunąć grafiku',

  EXTERNAL_RESERVATION_CREATED: 'Rezerwacja zewnętrzna została dodana',
  EXTERNAL_RESERVATION_CREATE_ERROR: 'Nie udało się dodać rezerwacji zewnętrznej',
  EXTERNAL_RESERVATION_DELETED: 'Rezerwacja zewnętrzna została usunięta',
  EXTERNAL_RESERVATION_DELETE_ERROR: 'Nie udało się usunąć rezerwacji zewnętrznej',

  HEALTH_RECORD_CREATED: 'Karta zdrowia została utworzona',
  HEALTH_RECORD_CREATE_ERROR: 'Nie udało się utworzyć karty zdrowia',
  EXAMINATION_ADDED: 'Badanie zostało dodane',
  EXAMINATION_ADD_ERROR: 'Nie udało się dodać badania',
  VACCINATION_ADDED: 'Szczepienie zostało dodane',
  VACCINATION_ADD_ERROR: 'Nie udało się dodać szczepienia',
  PRESCRIPTION_ADDED: 'Recepta została dodana',
  PRESCRIPTION_ADD_ERROR: 'Nie udało się dodać recepty',
  TREATMENT_ADDED: 'Leczenie zostało dodane',
  TREATMENT_ADD_ERROR: 'Nie udało się dodać leczenia',

  PORTAL_SESSION_ERROR: 'Nie udało się otworzyć portalu subskrypcji',

  INTERNAL_NOTE_CREATED: 'Notatka została dodana',
  INTERNAL_NOTE_CREATE_ERROR: 'Nie udało się dodać notatki',
  INTERNAL_NOTE_UPDATED: 'Notatka została zaktualizowana',
  INTERNAL_NOTE_UPDATE_ERROR: 'Nie udało się zaktualizować notatki',
  INTERNAL_NOTE_DELETED: 'Notatka została usunięta',
  INTERNAL_NOTE_DELETE_ERROR: 'Nie udało się usunąć notatki',
} as const;
